export default __webpack_public_path__ + "static/media/chapter2.aefd4be6.png";